import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-functions-hoisting',
  slug: 'hoisting',
  title: 'Hoisted or not?',
  type: 'predict',
  estSeconds: 60,
  contentVersion: 1,
});
